import React from "react";

import banner from "../../assests/banner.png";

export default function OBAVisionComponent() {
  return (
    <div
      className="rounded-3 border-vcg-muted p-4 p-lg-5 mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-left"
    >
      {/* Heading */}
      <div className="mb-4">
        <h3 className="fw-bold">The Vision of the Old Boys' Association</h3>
      </div>

      {/* Description */}
      <p
        className="text-secondary mb-4"
        style={{
          textAlign: "justify",
          lineHeight: "1.8",
        }}
      >
        The vision of the Old Boys' Association is to unite every generation of
        Vidyalokans through a shared purpose, preserving our proud heritage
        while inspiring collaboration, service, and excellence for the continued
        progress of Vidyaloka College.
      </p>

      {/* Vision Statement */}
      <div
        className="mx-auto rounded-3 p-4 text-center mb-5"
        style={{
          maxWidth: "750px",
          backgroundColor: "#f8f9fa",
          borderLeft: "5px solid #3c0008",
        }}
      >
        <p
          className="fw-bold mb-2"
          style={{
            fontSize: "1.4rem",
            color: "#3c0008",
            fontStyle: "italic",
            lineHeight: "1.6",
          }}
        >
          "Connecting past, present, and future generations under one flag"
        </p>

        <small className="text-muted">
          — Vision of the Vidyaloka College Old Boys' Association
        </small>
      </div>

      {/* Vision Concept Image */}
      <div className="text-center overflow-hidden" style={{ width: "100%" }}>
        <img
          src={banner}
          alt="Vision Banner"
          className="img-fluid rounded-3"
          style={{
            width: "100%",
            maxWidth: "500px",
            height: "auto",
            display: "block",
            margin: "0 auto",
          }}
        />

        <p
          className="text-muted small mt-3 mb-0 mx-auto"
          style={{
            maxWidth: "600px",
            lineHeight: "1.6",
          }}
        >
          An AI-generated image reflecting the vision of the Association, based
          on a concept by <strong>Mr. Sampath Duminda De Silva</strong>.
        </p>
      </div>
    </div>
  );
}
